import { FieldConstraint, LangageIso6391 } from "@tfg/db"
import _ from "lodash"
import { z } from "zod"

import { standardString } from "@tfg/types/schemas/utils"

export const CustomFieldValueSchema = z.object({
  id: z.number().int(),
  operationId: z.number().int(),
  customFieldDefinitionId: z.number().int(),
  value: z.string(),
  documentId: z.string().uuid().nullable(),
})
export type CustomFieldValueValidationType = z.infer<
  typeof CustomFieldValueSchema
>

const textContent = z.object({
  originalText: z.string().trim().nonempty(),
  TextTranslation: z.array(
    z.object({
      translatedLanguage: z.nativeEnum(LangageIso6391),
      translation: z.string(),
    })
  ),
})

export const CustomFieldDefinitionSchema = z.object({
  id: z.number().int(),
  forActivityId: z.string().uuid(),
  textContent,
  constraint: z.nativeEnum(FieldConstraint),
  enumValuesOriginalText: z.array(
    z.object({
      originalText: standardString(),
      ecobalyseBlayseFieldValueToTextContentId: z.string().uuid().nullable(),
    })
  ),
  csvColumnName: z.string(),
  message: textContent.nullable(),
  onActivityId: z.string().uuid().nullable(),
  min: z.coerce.number().nullable(),
  max: z.coerce.number().nullable(),
  ecobalyseBalyseFieldId: z.string().uuid().nullable(),
  enabledForOrganizationsIds: z.array(z.string().uuid()),
  documentRequirement: z.enum(["NONE", "OPTIONAL", "REQUIRED"]),
  fieldRequirement: z.enum(["OPTIONAL", "REQUIRED"]),
})

export type CustomFieldDefinitionValidationType = z.infer<
  typeof CustomFieldDefinitionSchema
>

export const CustomFieldDefinitionCreateSchema =
  CustomFieldDefinitionSchema.omit({
    id: true,
  }).refine(
    (data) =>
      data.constraint !== "SELECT" ||
      _.uniq(data.enumValuesOriginalText).length > 1,
    {
      message: "Must have more than 1 unique list value",
      path: ["constraint"],
    }
  )

export type CustomFieldDefinitionCreateValidationType = z.infer<
  typeof CustomFieldDefinitionCreateSchema
>

export const CustomFieldDefinitionUpdateParamsSchema = z.object({
  id: z.coerce.number().int(),
})

export const CustomFieldDefinitionSyncToProductsParamsSchema = z.object({
  orgId: z.string().uuid().optional(),
})

export type CustomFieldDefinitionSyncToProductsParamsValidationType = z.infer<
  typeof CustomFieldDefinitionSyncToProductsParamsSchema
>
